import { FetchEngagementsPayload } from "PFCore/services/engagements";

export const engagementsKeys = {
  all: () => ["engagements"],
  list: (params?: FetchEngagementsPayload) => [...engagementsKeys.all(), params]
};
